export const FORM = {
	PHONE_PATTERN: /^56\d{9}$/,
	PHONE_EXAMPLE: '56 11 111 1111',
	MAPS_CENTER: { lat: -27, lng: -60 },
	REGION_LABEL: 'Región',
	COMMUNE_LABEL: 'Comuna',
	STREE_LABEL: 'Barrio',
};
